module.exports = __webpack_public_path__ + "static/img/quote-open.be7d1a91.svg";